import { createContext, useContext } from "react";

import { SiteSettings } from "@/sanity/types";

const SiteSettingsContext = createContext<SiteSettings | null>(null);

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context)
    throw new Error(
      "useSiteSettings must be used within a SiteSettingsProvider"
    );
  return context;
};

export const SiteSettingsProvider = ({
  settings,
  children,
}: {
  settings: SiteSettings;
  children: React.ReactNode;
}) => {
  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
